export function RenderLabelPersonTitle(label){
    let result ;
    if(label === "Tn"){
        result = "Tuan"
    }
    if(label === "Ny"){
        result = "Nyonya"
    }
    return result;
}